import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import QuestionsContainer from '../../common/QuestionsContainer';
import ProfileSuggestionModal from '../../ProfileSuggestionModal';
import './EditRoles.scss';
var getPaginatedQuestionIds = function getPaginatedQuestionIds(ids) {
  return ids.map(function (id) {
    return [id];
  });
};
var EditRoles = /*#__PURE__*/function (_Component) {
  function EditRoles(props) {
    var _this;
    _classCallCheck(this, EditRoles);
    _this = _callSuper(this, EditRoles, [props]);
    _this.state = {
      isHovering: false,
      showModal: false,
      answers: props.answers
    };
    _this.handleMouseOver = _this.handleMouseOver.bind(_this);
    _this.handleMouseLeave = _this.handleMouseLeave.bind(_this);
    _this.handleShowModal = _this.handleShowModal.bind(_this);
    _this.handleCloseModal = _this.handleCloseModal.bind(_this);
    _this.handleAppendTags = _this.handleAppendTags.bind(_this);
    _this.handleClearSuggestions = _this.handleClearSuggestions.bind(_this);
    return _this;
  }
  _inherits(EditRoles, _Component);
  return _createClass(EditRoles, [{
    key: "handleMouseOver",
    value: function handleMouseOver() {
      this.setState({
        isHovering: true
      });
    }
  }, {
    key: "handleMouseLeave",
    value: function handleMouseLeave() {
      var showModal = this.state.showModal;
      if (!showModal) {
        this.setState({
          isHovering: false
        });
      }
    }
  }, {
    key: "handleShowModal",
    value: function handleShowModal() {
      this.setState({
        showModal: true
      });
    }
  }, {
    key: "handleCloseModal",
    value: function handleCloseModal() {
      var _this2 = this;
      var _this$props = this.props,
        getAnswers = _this$props.getAnswers,
        updateCompletionPercentage = _this$props.updateCompletionPercentage;
      getAnswers().then(function (response) {
        updateCompletionPercentage();
        _this2.setState({
          answers: response.data,
          showModal: false,
          isHovering: false
        });
      });
    }
  }, {
    key: "handleAppendTags",
    value: function handleAppendTags() {
      var _this3 = this;
      var _this$props2 = this.props,
        updateSuggestedTags = _this$props2.updateSuggestedTags,
        getAnswers = _this$props2.getAnswers,
        updateCompletionPercentage = _this$props2.updateCompletionPercentage;
      updateSuggestedTags([], 'HigherLevelRole');
      getAnswers().then(function (response) {
        updateCompletionPercentage();
        _this3.setState({
          answers: response.data,
          showModal: false,
          isHovering: false
        });
      });
    }
  }, {
    key: "handleClearSuggestions",
    value: function handleClearSuggestions(tagIds) {
      var _this$props3 = this.props,
        updateSuggestedTags = _this$props3.updateSuggestedTags,
        suggestedTags = _this$props3.suggestedTags;
      updateSuggestedTags(suggestedTags.HigherLevelRole.filter(function (tag) {
        return !tagIds.includes(tag.id);
      }), 'HigherLevelRole');
    }
  }, {
    key: "renderEdit",
    value: function renderEdit() {
      var _this4 = this;
      var _this$props4 = this.props,
        editMode = _this$props4.editMode,
        suggestedTags = _this$props4.suggestedTags,
        fullView = _this$props4.fullView;
      var isHovering = this.state.isHovering;
      if ((!suggestedTags.HigherLevelRole || !suggestedTags.HigherLevelRole.length) && (isHovering || editMode) && fullView) {
        return /*#__PURE__*/React.createElement("a", {
          className: "edit-roles medium-weight",
          tabIndex: 0,
          role: "button",
          onClick: function onClick() {
            return _this4.handleShowModal();
          }
        }, "Edit");
      }
      return null;
    }
  }, {
    key: "renderRoles",
    value: function renderRoles(roles) {
      var _this5 = this;
      var fullView = this.props.fullView;
      if (roles && roles.length > 0) {
        return /*#__PURE__*/React.createElement(Fragment, null, roles.map(function (role) {
          var proficiency = role.proficiency ? " (".concat(role.proficiency, ")") : '';
          return /*#__PURE__*/React.createElement("span", {
            className: "badge medium blue-light body-text-2 mb-2 me-2",
            key: role.value
          }, role.label, proficiency);
        }), this.renderEdit());
      }
      if (fullView) {
        return /*#__PURE__*/React.createElement("a", {
          className: "add-answer body-text-2",
          tabIndex: 0,
          role: "button",
          onClick: function onClick() {
            return _this5.handleShowModal();
          }
        }, /*#__PURE__*/React.createElement("i", {
          className: "fa fa-plus"
        }), "Add Roles");
      }
      return null;
    }
  }, {
    key: "renderRoleSuggestions",
    value: function renderRoleSuggestions() {
      var _this$props5 = this.props,
        csrfToken = _this$props5.csrfToken,
        suggestedTags = _this$props5.suggestedTags,
        showSuggestionModal = _this$props5.showSuggestionModal;
      if (!suggestedTags.HigherLevelRole || suggestedTags.HigherLevelRole.length === 0) return null;
      return /*#__PURE__*/React.createElement(ProfileSuggestionModal, {
        tags: suggestedTags.HigherLevelRole,
        csrfToken: csrfToken,
        appendTags: this.handleAppendTags,
        clearTags: this.handleClearSuggestions,
        forceShow: showSuggestionModal === 'HigherLevelRoles'
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        showModal = _this$state.showModal,
        answers = _this$state.answers;
      var _this$props6 = this.props,
        questionnaireQuestions = _this$props6.questionnaireQuestions,
        questionableId = _this$props6.questionableId,
        questionableType = _this$props6.questionableType,
        questionnaireName = _this$props6.questionnaireName,
        csrfToken = _this$props6.csrfToken;
      var answer = answers.find(function (a) {
        return a.question_key === 'Roles';
      });
      return /*#__PURE__*/React.createElement("div", {
        onMouseOver: this.handleMouseOver,
        onMouseLeave: this.handleMouseLeave,
        className: "mb-2"
      }, this.renderRoles(answer.answer), this.renderRoleSuggestions(), /*#__PURE__*/React.createElement(QuestionsContainer, {
        key: "".concat(questionnaireName),
        questionnaireName: questionnaireName,
        questionIds: [questionnaireQuestions[0]],
        questionType: answer.question_type,
        questionableId: questionableId,
        questionableType: questionableType,
        csrfToken: csrfToken,
        modalOpen: showModal,
        withModal: true,
        paginated: true,
        paginatedQuestionIds: getPaginatedQuestionIds(questionnaireQuestions),
        closeModalCallback: this.handleCloseModal,
        owner: true
      }));
    }
  }]);
}(Component);
EditRoles.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  editMode: PropTypes.bool.isRequired,
  fullView: PropTypes.bool.isRequired,
  answers: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  getAnswers: PropTypes.func.isRequired,
  questionableId: PropTypes.number.isRequired,
  questionableType: PropTypes.string.isRequired,
  questionnaireName: PropTypes.string.isRequired,
  questionnaireQuestions: PropTypes.arrayOf(PropTypes.number).isRequired,
  updateCompletionPercentage: PropTypes.func.isRequired,
  suggestedTags: PropTypes.shape({}),
  updateSuggestedTags: PropTypes.func,
  showSuggestionModal: PropTypes.string
};
EditRoles.defaultProps = {
  suggestedTags: {},
  updateSuggestedTags: function updateSuggestedTags() {},
  showSuggestionModal: ''
};
export default EditRoles;